import { DiscriminationOfSubjectsPage } from './DiscriminationOfSubjectsPage';
export default DiscriminationOfSubjectsPage;
